import { useQuery } from "react-query";
import axios from "infra/http";
import { CobrancaDetails } from "../typings";

function useDetalhesCobranca(
  id: string,
  data: string,
  incluirContasPendentes?: "0" | "1"
) {
  return useQuery(
    [`/v1/cobranca-${id}`, incluirContasPendentes],
    async () => {
      const res = await axios.get<CobrancaDetails>(`/v1/cobranca/${id}`, {
        params: {
          data,
          incluirContasPendentes,
        },
      });

      return res.data;
    },
    {
      enabled: !!id && !!data,
    }
  );
}

export default useDetalhesCobranca;
